export default "__VITE_ASSET__fe09d4d7__"